import { isOverlayableText } from './shared'

/**
 * Short text list fields (e.g. Generic Table `cells`) are plain `string[]` on both sides.
 */
export const overlayStringList = (value: unknown, field: unknown): unknown | undefined => {
  if (!Array.isArray(field) || !Array.isArray(value)) return undefined
  if (field.length === 0 && value.length === 0) return field
  if (!field.every(isOverlayableText)) return undefined
  if (!value.every(item => typeof item === 'string')) return undefined
  return field
}
